import React from 'react';
import { Wrench, Clock } from 'lucide-react';

const MaintenanceScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-orange-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="/laptopmarket_logo.svg" 
            alt="Laptop Market" 
            className="h-16 md:h-20"
          />
        </div>
        
        <div className="flex justify-center mb-6">
          <div className="relative">
            <Wrench className="w-24 h-24 text-yellow-600 animate-pulse" />
            <Clock className="w-12 h-12 text-orange-400 absolute -bottom-2 -right-2" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
          Karbantartás alatt
        </h1>
        
        <p className="text-xl text-gray-600 mb-6">
          Jelenleg a weboldal karbantartása folyik
        </p>
        
        <div className="bg-yellow-50 rounded-lg p-6 mb-8">
          <p className="text-gray-700 leading-relaxed">
            Dolgozunk azon, hogy még jobb élményt nyújtsunk Önnek. 
            A weboldal hamarosan újra elérhető lesz.
          </p>
        </div>
        
        <div className="space-y-3 text-gray-600">
          <p className="flex items-center justify-center gap-2">
            <span className="font-semibold">Email:</span>
            <a href="mailto:info@laptopmarket.hu" className="text-yellow-600 hover:text-yellow-700 transition-colors">
              info@laptopmarket.hu
            </a>
          </p>
          <p className="flex items-center justify-center gap-2">
            <span className="font-semibold">Telefon:</span>
            <a href="tel:+36306264279" className="text-yellow-600 hover:text-yellow-700 transition-colors">
              +36 30 626 4279
            </a>
          </p>
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Köszönjük türelmét és megértését!
          </p>
          <p className="text-sm text-gray-400 mt-2">
            Webissimo Kft.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
